export default "__VITE_ASSET__8XGRc$Ye__"